import React, {
  ReactNode,
  useState,
  RefObject,
  Dispatch,
  SetStateAction,
} from "react";
import ReactSlick, { Settings } from "react-slick";
import styled from "styled-components";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { assets } from "@util/constants";
import { IconButton } from "@global";
interface Props {
  children: ReactNode;
  hideArrow?: boolean;
  moreSettings?: any;
  sliderRef?: RefObject<ReactSlick>;
  variableWidth?: boolean;
  adaptiveHeight?: boolean;
  infinite?: boolean;
  slidesToShow?: number;
  slidesToScroll?: number;
  hideDots?: boolean;
  selectedIndex?: number;
  setSelectedIndex?: Dispatch<SetStateAction<number>>;
  hasDarkBackground?: boolean;
  margin?: string;
  width?: string;
  alignDots?: "left" | "center" | "right";
  dotMargins?: string;
  dotsToLeft?: boolean;
  autoplay?: boolean;
  slickNextRight?: number;
  slickNextLeft?: number;
  iconButton?: boolean;
  nextIcon?: JSX.Element;
  prevIcon?: JSX.Element;
  speed?: number;
  recipeInnerArrows?: boolean;
  hideOnMobile?: boolean;
  centerMode?: boolean;
}

const Arrow = styled.img`
  object-fit: contain;
`;

const Carousel = ({
  children,
  hideArrow,
  sliderRef,
  variableWidth,
  adaptiveHeight,
  infinite,
  slidesToShow,
  slidesToScroll,
  hideDots,
  selectedIndex,
  setSelectedIndex,
  hasDarkBackground,
  autoplay,
  iconButton,
  nextIcon,
  prevIcon,
  speed,
  hideOnMobile,
  centerMode,
}: Props) => {
  const [slideIndex, setSlideIndex] = useState(0);

  const settings: Settings = {
    dots: hideDots ? false : true,
    infinite: infinite ?? true,
    speed: 500,
    centerMode: centerMode ?? false,
    autoplay: autoplay ? autoplay : false,
    autoplaySpeed: speed ? speed : 3000,
    slidesToShow: slidesToShow ?? 1,
    slidesToScroll: slidesToScroll ?? 1,
    arrows: hideArrow ? false : true,
    pauseOnHover: true,
    lazyLoad: "ondemand",
    nextArrow: hideArrow
      ? undefined
      : nextIcon ??
      (iconButton ? (
        <IconButton
          alt={`next-index-${slideIndex + 1}`}
          hideOnMobile={hideOnMobile}
        />
      ) : (
        <Arrow
          alt={`next-index-${selectedIndex ?? slideIndex + 1}`}
          width="20px"
          height="20px"
          src={hasDarkBackground ? assets.arrowRightWhite : assets.arrowRight}
        />
      )),
    prevArrow: hideArrow
      ? undefined
      : prevIcon ??
      (iconButton ? (
        <IconButton
          alt={`next-index-${slideIndex - 1}`}
          hideOnMobile={hideOnMobile}
        />
      ) : (
        <Arrow
          alt={`next-index-${selectedIndex ?? slideIndex - 1}`}
          width="20px"
          height="20px"
          src={hasDarkBackground ? assets.arrowLeftWhite : assets.arrowLeft}
        />
      )),
    beforeChange: (_current, next) => {
      setSelectedIndex ? setSelectedIndex(next) : setSlideIndex(next);
    },
    variableWidth,
    adaptiveHeight,
  };

  return (
    <ReactSlick ref={sliderRef} {...settings}>
      {children}
    </ReactSlick>
  );
};

export default Carousel;
